import * as yup from 'yup';
import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

const config = {
    name: 'scheduleProgram',
    actions: [
        { type: 'request', name: 'getSchedules' },
        { type: 'request', name: 'getSchedule' },
        { type: 'request', name: 'createSchedule' },
        { type: 'request', name: 'updateSchedule' },
        { type: 'request', name: 'deleteSchedule' },
        { type: 'request', name: 'bulkCreateSchedules' },
        { type: 'request', name: 'getWeeklyStats' },
        { type: 'request', name: 'getCoverageReport' },
        { type: 'request', name: 'getShops' },
        { type: 'request', name: 'getEmployees' },
        // Vacation requests
        { type: 'request', name: 'getVacationRequests' },
        { type: 'request', name: 'createVacationRequest' },
        { type: 'request', name: 'approveVacationRequest' },
        { type: 'request', name: 'rejectVacationRequest' },
        { type: 'request', name: 'cancelVacationRequest' },
        // Change requests
        { type: 'request', name: 'getChangeRequests' },
        { type: 'request', name: 'createSwapRequest' },
        { type: 'request', name: 'employeeApproveChange' },
        { type: 'request', name: 'employeeRejectChange' },
        { type: 'request', name: 'approveChangeRequest' },
        { type: 'request', name: 'rejectChangeRequest' },
        { type: 'request', name: 'overrideChangeRequest' }
    ],
    endpoints: {
        schedules: '/schedules',
        schedulesByDateRange: '/schedules/by-date-range',
        schedule: '/schedules/[id]',
        bulkSchedules: '/schedules/bulk',
        weeklyStats: '/schedules/weekly-stats',
        coverageReport: '/schedules/coverage-report',
        shops: '/shops',
        shopEmployees: '/shops/[id]/employees',
        // Vacation
        vacationRequests: '/vacation-requests',
        vacationRequest: '/vacation-requests/[id]',
        pendingVacations: '/vacation-requests/pending',
        approveVacation: '/vacation-requests/[id]/approve',
        rejectVacation: '/vacation-requests/[id]/reject',
        cancelVacation: '/vacation-requests/[id]/cancel',
        // Change requests
        changeRequests: '/schedule-change-requests',
        pendingChangeRequests: '/schedule-change-requests/pending-admin',
        createSwap: '/schedule-change-requests/swap',
        employeeApproveChange: '/schedule-change-requests/[id]/employee-approve',
        employeeRejectChange: '/schedule-change-requests/[id]/employee-reject',
        approveChange: '/schedule-change-requests/[id]/admin-approve',
        rejectChange: '/schedule-change-requests/[id]/admin-reject',
        overrideChange: '/schedule-change-requests/[id]/admin-override'
    },
    defaults: {
        createSchedule: {
            shopId: null,
            employeeId: null,
            date: '',
            startTime: '09:00',
            endTime: '17:00',
            breakMinutes: 30,
            type: 'regular',
            notes: ''
        },
        createVacation: {
            startDate: '',
            endDate: '',
            type: 'vacation',
            reason: ''
        }
    },
    validations: {
        schedule: yup.object().shape({
            shopId: yup.number().required("Selectați un magazin"),
            employeeId: yup.number().required("Selectați un angajat"),
            date: yup.string().required("Data este obligatorie"),
            startTime: yup.string().required("Ora de început este obligatorie"),
            endTime: yup.string().required("Ora de sfârșit este obligatorie")
        }),
        vacation: yup.object().shape({
            startDate: yup.string().required("Data de început este obligatorie"),
            endDate: yup.string().required("Data de sfârșit este obligatorie"),
            type: yup.string().required("Tipul este obligatoriu")
        })
    }
}

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
